module.exports = __webpack_public_path__ + "static/media/vhs.e3ae95cf.svg";